import { FeatureFlag, useFeatureFlagsStore } from 'stores/featureFlagsStore';

export function useExternalAgentEnabled(): boolean {
  return useFeatureFlagsStore((state) =>
    state.isFeatureEnabled(FeatureFlag.external_agent)
  );
}
